import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import { useDeleteCommentDraft } from "./hooks/useDeleteCommentDraft";

function DeleteDraftMenuButton({
  draftGid,
  onDeletionStarted,
  onDraftDeleted,
  onError,
}) {
  const { deleteDraft } = useDeleteCommentDraft(
    draftGid,
    onDraftDeleted,
    onError
  );

  if (!draftGid) {
    return null;
  }

  return (
    <Button
      data-test="delete-draft-menu-item"
      icon="delete"
      content="Delete Draft"
      onClick={() => {
        onDeletionStarted();
        deleteDraft();
      }}
    />
  );
}

DeleteDraftMenuButton.defaultProps = {
  draftGid: "",
  onError: () => {},
};

DeleteDraftMenuButton.propTypes = {
  draftGid: PropTypes.string,
  onDeletionStarted: PropTypes.func.isRequired,
  onDraftDeleted: PropTypes.func.isRequired,
  onError: PropTypes.func,
};

export default DeleteDraftMenuButton;
